// extracted by mini-css-extract-plugin
module.exports = {"videoEmbedTokens":"videoEmbed_videoEmbedTokens__eQujk","videoEmbed":"videoEmbed_videoEmbed__n9Tx3"};